import React from 'react';
import Presenter from './Presenter';
import Container from './Container';

const Terms = (props) => {
	return <Container 
		{...props}
		render={(containerProps,other)=><React.Fragment>
			<Presenter 
				{...containerProps}
				{...other}
			/>
		</React.Fragment>}
	/>;
};
export default (Terms);